import { NavLink, Outlet } from 'react-router-dom';
import { TRIP_INFO } from '../data/attendees';
import logo from '../logo.svg';

function Layout() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="header-brand">
          <img src={logo} alt={TRIP_INFO.university} className="brand-logo" />
          <div className="brand-text">
            <span className="brand-university">{TRIP_INFO.university}</span>
            <span className="brand-event">مخطط رحلة {TRIP_INFO.event}</span>
          </div>
        </div>
        <nav className="app-nav">
          <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            الجدول
          </NavLink>
          {/* <NavLink to="/attendance" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            حضور وفد LEAP
          </NavLink> */}
        </nav>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <footer className="app-footer">
        <p>{TRIP_INFO.university} · {TRIP_INFO.event} · {TRIP_INFO.dates}</p>
        <p className="footer-note">Re-check the official LEAP app each evening for location changes.</p>
      </footer>
    </div>
  );
}

export default Layout;
